import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from 'lucide-react';
import type { Direction } from '../lib/types';
import { DIRECTION_LABELS } from '../lib/constants';

const DIRECTIONS: Direction[] = ['N', 'E', 'S', 'W'];
const ICONS = { N: ArrowUp, E: ArrowRight, S: ArrowDown, W: ArrowLeft };

interface Props {
  value: Direction | null;
  onChange: (direction: Direction) => void;
  theme?: 'light' | 'dark';
}

export default function DirectionPicker({ value, onChange, theme = 'light' }: Props) {
  const dark = theme === 'dark';
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" role="group" aria-label="Direction home">
      {DIRECTIONS.map((direction) => {
        const Icon = ICONS[direction];
        const active = value === direction;
        return (
          <button
            key={direction}
            type="button"
            onClick={() => onChange(direction)}
            aria-pressed={active}
            className="flex items-center justify-center gap-2 rounded-xl border px-3 py-3 text-sm font-bold transition-colors"
            style={active
              ? { backgroundColor: '#17A24A', borderColor: '#17A24A', color: '#ffffff' }
              : dark
                ? { backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border)', color: 'var(--text-secondary)' }
                : { backgroundColor: '#ffffff', borderColor: '#e5e7eb', color: '#374151' }}
          >
            <Icon className="w-4 h-4" strokeWidth={2.5} />
            <span>{DIRECTION_LABELS[direction]}</span>
          </button>
        );
      })}
    </div>
  );
}
